import { Outlet } from "react-router-dom";
import SettingsNavbar from "../components/navbars/SettingsNavbar";

export default function SettingsLayout() {
    return (
        <section className="main-layer-section">
            <SettingsNavbar />
            <section className="content-layer-section">
                <Outlet />
            </section>
        </section>
    );
}
